var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 37,
    viewBox: "0 0 70 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.442974,
    y: 0.442974,
    width: 68.218,
    height: 35.4379,
    rx: 16.39,
    fill: "#FF9690"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.442974,
    y: 0.442974,
    width: 68.218,
    height: 35.4379,
    rx: 16.39,
    stroke: "#A72F2C",
    strokeWidth: 0.885948
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 25.2495C30.7172 25.2495 30.3802 25.1092 30.1002 24.8286C29.8203 24.5481 29.68 24.2117 29.6794 23.8196V12.8462H29.2364C29.1106 12.8462 29.0055 12.8037 28.921 12.7186C28.8366 12.6336 28.7941 12.5281 28.7935 12.4023C28.7929 12.2765 28.8354 12.1714 28.921 12.0869C29.0067 12.0025 29.1118 11.9603 29.2364 11.9603H32.3373C32.3373 11.7772 32.4052 11.6177 32.541 11.4818C32.6769 11.346 32.8363 11.2781 33.0194 11.2781H36.9708C37.1539 11.2781 37.3133 11.346 37.4492 11.4818C37.585 11.6177 37.6529 11.7772 37.6529 11.9603H40.7538C40.8796 11.9603 40.9847 12.0028 41.0692 12.0878C41.1536 12.1729 41.1961 12.2783 41.1967 12.4041C41.1973 12.5299 41.1548 12.6351 41.0692 12.7195C40.9835 12.804 40.8784 12.8462 40.7538 12.8462H40.3108V23.8187C40.3108 24.212 40.1705 24.5487 39.89 24.8286C39.6094 25.1086 39.2727 25.2489 38.88 25.2495H31.1111ZM39.4248 12.8462H30.5654V23.8187C30.5654 23.9775 30.6164 24.1081 30.7186 24.2103C30.8208 24.3124 30.9516 24.3635 31.1111 24.3635H38.88C39.0389 24.3635 39.1694 24.3124 39.2716 24.2103C39.3737 24.1081 39.4248 23.9775 39.4248 23.8187V12.8462ZM33.4961 22.5916C33.6219 22.5916 33.7273 22.5491 33.8124 22.4641C33.8974 22.379 33.9396 22.2739 33.939 22.1487V15.0611C33.939 14.9353 33.8965 14.8301 33.8115 14.7457C33.7264 14.6612 33.621 14.6187 33.4952 14.6181C33.3694 14.6175 33.2643 14.66 33.1798 14.7457C33.0953 14.8313 33.0531 14.9364 33.0531 15.0611V22.1487C33.0531 22.2745 33.0956 22.3796 33.1807 22.4641C33.2657 22.5491 33.3709 22.5916 33.4961 22.5916ZM36.495 22.5916C36.6208 22.5916 36.7259 22.5491 36.8104 22.4641C36.8949 22.379 36.9371 22.2739 36.9371 22.1487V15.0611C36.9371 14.9353 36.8946 14.8301 36.8095 14.7457C36.7245 14.6606 36.6193 14.6181 36.4941 14.6181C36.3683 14.6181 36.2629 14.6606 36.1778 14.7457C36.0928 14.8307 36.0506 14.9359 36.0511 15.0611V22.1487C36.0511 22.2745 36.0937 22.3796 36.1787 22.4641C36.2638 22.5485 36.3692 22.591 36.495 22.5916Z",
    fill: "#A72F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletered);
export default __webpack_public_path__ + "static/media/Deletered.aa0931313c4caf563c879d2b4b81df4c.svg";
export { ForwardRef as ReactComponent };